import React from "react";

function User() {
  return (
    <div>
      <h6>User</h6>
    </div>
  );
}

export default User;
